import React from 'react';
import { NavLink } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash, FaEye, FaCogs } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';

import ThirdPartyAPI from '../../../api/ThirdPartyAPI';
import Const from '../../../util/Constants';
import Util from '../../../util/Util';
import withRouter from '../../../util/WithRouter';
import Display from '../../../util/Display';
import ApiUiController from '../../../controller/ApiUiController';

class Acres99List extends React.Component {

  constructor(props) {
    super(props);
    this.apis = [];
    this.state = { inApiCall: true };
    this.path = this.props.match.path;
    this.logs = this.path.substring(0, this.path.lastIndexOf('/'));
    const model = reactLocalStorage.getObject(Const.Model).api;
    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Add = Util.isAllow(model.permission, Const.PermAdd);
    this.Update = Util.isAllow(model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(model.permission, Const.PermDelete);
  }

  componentDidMount() { if (this.List) ThirdPartyAPI.list(6, this.onReceived, this.onFail); }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = apis => { this.apis = apis; this.setState({ inApiCall: false }); };

  confirmDelete = index => {
    const message = `Are you sure you want to delete to ${this.apis[index].name}`;
    Util.confirmAlert('Delete', message, 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      ThirdPartyAPI.delete(this.apis[index].id, this.onDelete, this.onFail);
    });
  };
  onDelete = () => {
    Util.showNotification('Successful', 'Role Deleted successfully.', 'success');
    ThirdPartyAPI.list(6, this.onReceived, this.onFail);
  };

  render() {
    if (!this.List) return null;
    const apiUI = this.apis.map((api, _i) => (
      <tr key={`api_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{api.name}</td>
        <td>{Display.ModelLabelValue('user', api.created_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(api.created_date)}</td>
        <td>{Display.ModelLabelValue('user', api.updated_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(api.updated_date)}</td>
        <td>
          <NavLink to={`${this.path}/preview/${api.id}`} className="buttons whtsapp">
            <FaEye /> Details</NavLink>
          {this.Update &&
            <NavLink to={`${this.path}/add-edit/${api.id}`} className="buttons update">
              <FaPencilAlt /> Update</NavLink>
          }
          {api.status !== Const.AlwaysActive && this.Delete &&
            <span onClick={() => this.confirmDelete(_i)} className="buttons delete"><FaTrash /> Delete</span>
          }
          <NavLink to={`${this.logs}/api-log/${api.id}`} className="buttons add"><FaCogs /> Logs</NavLink>
        </td>
      </tr>
    ));

    return (
      <>
        <div className="sectionlist pt-3">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6 pb-3"> <h3>99Acres</h3> </div>
              <div className="col-md-6 text-right pb-3">
                {this.Add &&
                  <NavLink to={`${this.path}/add-edit/0`} className="buttons success">
                    + Add 99Acres
                  </NavLink>
                }
              </div>
              <div className="col-md-12">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Name</th>
                      <th>Created By</th>
                      <th>Created Date</th>
                      <th>Updated By</th>
                      <th>Updated Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ApiUiController inApiCall={this.props.inApiCall}>
                      {apiUI}
                    </ApiUiController>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default withRouter(Acres99List);